import React from 'react';
import { ArrowRight, Shield } from 'lucide-react';
import './Hero.css';

const Hero = () => {
  return (
    <section className="hero" data-testid="hero-section">
      <div className="hero-bg">
        <div className="hero-grid"></div>
        <div className="hero-glow"></div>
      </div>
      
      <div className="container hero-container">
        <div className="hero-content">
          <div className="hero-badge" data-testid="hero-badge">
            <Shield size={14} />
            <span>Enterprise Governance Platform</span>
          </div>
          
          <h1 className="hero-title" data-testid="hero-title">
            Prevent AI Communication Mistakes Before They Go Public
          </h1>
          
          <p className="hero-subtitle" data-testid="hero-subtitle">
            The Governance Layer for AI-Generated Communication
          </p>
          
          <p className="hero-description" data-testid="hero-description">
            VantaSignal evaluates AI-generated communication against policy, alignment, and reputational risk before publication.
          </p>
          
          <div className="hero-actions" data-testid="hero-actions">
            <a 
              href="mailto:contact@vantasignal.app" 
              className="btn btn-primary"
              data-testid="hero-request-demo"
            >
              Request Demo
              <ArrowRight size={18} />
            </a>
            <a 
              href="https://app.vantasignal.app" 
              className="btn btn-secondary"
              data-testid="hero-view-platform"
              target="_blank"
              rel="noopener noreferrer"
            >
              View Platform
            </a>
          </div>
        </div>
        
        <div className="hero-visual" data-testid="hero-visual">
          <div className="dashboard-preview">
            <div className="dashboard-header">
              <div className="dashboard-dots">
                <span></span>
                <span></span>
                <span></span>
              </div>
              <span className="dashboard-title">VantaSignal Dashboard</span>
            </div>
            <div className="dashboard-content">
              <div className="dashboard-sidebar">
                <div className="sidebar-item active">
                  <span className="sidebar-icon"></span>
                  <span>Policy Engine</span>
                </div>
                <div className="sidebar-item">
                  <span className="sidebar-icon"></span>
                  <span>Draft Review</span>
                </div>
                <div className="sidebar-item">
                  <span className="sidebar-icon"></span>
                  <span>Audit Logs</span>
                </div>
                <div className="sidebar-item">
                  <span className="sidebar-icon"></span>
                  <span>Analytics</span>
                </div>
              </div>
              <div className="dashboard-main">
                <div className="dashboard-card">
                  <div className="card-header">Governance Score</div>
                  <div className="card-score">94<span>%</span></div>
                  <div className="card-bar">
                    <div className="card-bar-fill" style={{width: '94%'}}></div>
                  </div>
                </div>
                <div className="dashboard-metrics">
                  <div className="metric">
                    <span className="metric-value">127</span>
                    <span className="metric-label">Drafts Reviewed</span>
                  </div>
                  <div className="metric">
                    <span className="metric-value">23</span>
                    <span className="metric-label">Flagged</span>
                  </div>
                  <div className="metric">
                    <span className="metric-value">8</span>
                    <span className="metric-label">Blocked</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
